import { useEffect, useState } from 'react'
import { Grid } from '@material-ui/core'
import { Alert } from '@mui/material'

import StyledTypography from '../StyledTypography/StyledTypography'
// Style
import './messageDisplay.css'

const MessageDisplay = ({ messageList, setMessageList, timeToIn=500, timeToOut=5000 }) => {
    const [showingMessageList, setShowingMessageList] = useState([]);
    const maxSimultaneousMessages = 3;

    useEffect(() => {
        if (messageList.msgList.length > 0 && showingMessageList.length === 0 ){
            setTimeout( () => {
                setShowingMessageList(messageList.msgList.slice(0,maxSimultaneousMessages));
            }, timeToIn)
        }
    }, [messageList])

    useEffect(() => {
        if(showingMessageList.length > 0){
            const showedMessagesCount = showingMessageList.length;
            setTimeout( () => {
                setShowingMessageList([]);
                setMessageList(prev => ({msgList:prev.msgList.slice(showedMessagesCount, prev.msgList.length)}));
            }, timeToOut)
        } 
    }, [showingMessageList])

    return (
        <div className='message-display-main'>
            <Grid container direction='column'>
                { showingMessageList.map( (message, index) => {
                    return(
                        <Grid key={index} item className='message-display-item'>
                            <Alert severity={message.severity}>
                                <StyledTypography variant="body2">
                                    {message.message}
                                </StyledTypography> 
                            </Alert>
                        </Grid>
                    )
                })}
            </Grid>
        </div>
    )
}

export default MessageDisplay
